angular
.module( 'ribytRsvpApp' )
.directive( 'ticketGroup', function ( $sessionStorage, $rootScope, $state,  $sce ) {
    return {
        'restrict': 'E',
        'scope': {
            'inviteData': '=',
            'ticketData': '=',
            'invite': '='
        },
        'templateUrl': 'views/directives/tickets/ticketGroup.html',
        'link': function ( scope, element, attrs ) {

        }
    };
} );
